import '../../styles/web-components/save-for-later-list.scss';
import { sflData } from '../services/wishlist.service';
import { INLINE_CART_CLOSE } from '../constants/events.constants';
import { createCartLineItem } from '../helpers/cart.helper';
class SaveForLaterList extends HTMLElement {
    list = [];
    total;
    sflUnsub;
    constructor() {
        super();
        this.addEventListener("click", (e) => {
            const target = e.target;
            if (location.pathname === "/cart" && target.classList.contains("js-show-all")) {
                window.dispatchEvent(new CustomEvent(INLINE_CART_CLOSE));
                // eslint-disable-next-line wc/no-constructor-attributes
                this.querySelector('a').focus();
            }
        });
    }
    async connectedCallback() {
        this.showLoading();
        this.sflUnsub = sflData.subscribe(async (data) => {
            if (data && data.items.length) {
                const limit = +this.getAttribute("limit") || null;
                this.list = limit ? data.items.slice(0, limit) : data.items;
                this.total = data.pagination.totalcount;
                this.renderList();
            }
            else {
                this.hide();
            }
        });
    }
    disconnectedCallback() {
        this.sflUnsub?.();
        this.sflUnsub = undefined;
    }
    renderList() {
        this.innerHTML = `
    <div class="save-for-later-list__container">
      <div class="save-for-later-list__top-container">
        <div class="save-for-later-list__title">Saved For Later
          ${this.getAttribute("limit") ? "" : `<span>(${this.total})</span>`}
        </div>
        ${this.getAttribute("limit") ? `<a class="save-for-later-list__show-all js-show-all" href="/cart#cart-save-for-later">See All</a>` : ""}
        <!-- <button class="save-for-later-list__expand-button">Expand The List</button> -->
      </div>
      <div class="save-for-later-list__list"></div>
    </div>
    `;
        const listEls = this.list.map(item => {
            const data = mapSaveForLaterToCartLineItemData(item);
            return createCartLineItem(data, { actionsType: 'sfl', showQuantity: false, styleClass: 'cart-line-item--listed' });
        });
        this.querySelector('.save-for-later-list__list').append(...listEls);
    }
    hide() {
        this.innerHTML = '';
    }
    showLoading() {
        this.innerHTML = "<loading-spinner></loading-spinner>";
    }
}
if (!window.customElements.get("save-for-later-list")) {
    customElements.define("save-for-later-list", SaveForLaterList);
}
function mapSaveForLaterToCartLineItemData(sflItem) {
    return {
        url: sflItem.du,
        product_title: sflItem.dt,
        featured_image: {
            url: sflItem.iu,
            alt: null,
            aspect_ratio: null,
            height: null,
            width: null
        },
        options_with_values: sflItem.selectedOptions,
        final_price: sflItem.pr * 100,
        original_price: sflItem.pr * 100,
        product_id: sflItem.empi,
        variant_id: sflItem.epi,
        availableForSale: sflItem.availableForSale,
        badgingText: sflItem.badgingText,
        compareAtPrice: sflItem.compareAtPrice,
        colorDisplayValue: sflItem.colorDisplayValue
    };
}
